export default __webpack_public_path__ + "static/media/program_2026.d5989be0.pdf";